import { buildChecklistSalesEmailHeadStyles } from './checklistSalesEmailFonts';
import { getStaticChecklistOperationsEmailHeadingImages } from './checklistOperationsEmailHeadingImages';
import { buildChecklistSalesEmailHtmlContent } from './checklistSalesEmailTemplate';

const SITE_BASE = (process.env.REACT_APP_BASE_URL || 'https://antologia.tech').replace(/\/$/, '');

export { absolutizeEmailAssetUrls } from './renderChecklistSalesEmailHtml';

/**
 * HTML-письмо operations-чек-листа (/ready-for-ai).
 */
export function renderChecklistOperationsEmailHtml(data, { baseUrl = SITE_BASE, headingImages } = {}) {
  const normalizedBase = baseUrl.replace(/\/$/, '');
  const mergedHeadingImages = {
    ...getStaticChecklistOperationsEmailHeadingImages(),
    ...headingImages,
  };
  const content = buildChecklistSalesEmailHtmlContent(data, normalizedBase, mergedHeadingImages, {
    emailTestId: 'checklist-operations-email',
    readinessVariant: 'operations',
  });
  const headStyles = buildChecklistSalesEmailHeadStyles(normalizedBase);
  return `<!DOCTYPE html>
<html lang="ru">
<head>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <meta http-equiv="X-UA-Compatible" content="IE=edge" />
  <title>Результаты чек-листа готовности к AI</title>
  ${headStyles}
</head>
<body style="margin:0;padding:0;background-color:#f3f4f6;font-family:'Inter Display',Arial,Helvetica,sans-serif;">
${content}
</body>
</html>`;
}
